/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminUserMlpControllerImportCsv$Params {
      body: {

/**
 * CSV file with wallet addresses and MLP amounts
 */
'file': Blob;
}
}

export function adminUserMlpControllerImportCsv(http: HttpClient, rootUrl: string, params: AdminUserMlpControllerImportCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
'created'?: number;
'updated'?: number;
'errors'?: Array<string>;
'total'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, adminUserMlpControllerImportCsv.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      'created'?: number;
      'updated'?: number;
      'errors'?: Array<string>;
      'total'?: number;
      }>;
    })
  );
}

adminUserMlpControllerImportCsv.PATH = '/admin/user-mlp/import';
